import Vue from 'vue'
import { initCore } from 'src/lib/init.js'
import { initItemPage } from 'src/lib/item-page'
import BoundingBoxRepresentation from '/src/components/geospatial/BoundingBoxRepresentation.vue'
import DatasetDistributionsDisplay from 'src/components/dataset/pages/DatasetDistributionsDisplay.vue'

initCore()
initItemPage()

new Vue({
    el: '#vue-dataset-adv-cov-display',
    components: {
        // 'ddf-high-level-view': DatasetGroupHighLevel,
        'bounding-box-representation': BoundingBoxRepresentation,
        'dataset-distributions-display': DatasetDistributionsDisplay

    }
})
// Need to re-init drop downs
$('.dropdown-toggle').dropdown()
